/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateWorkPackageOwner } from '../../actions/workPackageActions';
import {
  addTaskOwner,
  editTaskOwner,
  removeTaskOwner
} from '../../actions/taskActions';

const ChangeOwner = props => {
  const {
    classes,
    result,
    task,
    oldOwnerId,
    users,
    updateTemporaryTaskOwner
  } = props;

  if (!result && !result.id && !task && !task.id) return null;

  let item = {};
  let usersList = [];
  let currentOwnerId = oldOwnerId;

  if (result && result.id) {
    item = result;
    currentOwnerId = item.owner_id;
    usersList = users.filter(u => u.id !== currentOwnerId);
  } else {
    item = task;
    const currentOwners = item.task_owner_ids || [];
    usersList = users.filter(
      user => !currentOwners.find(ownerId => ownerId === user.id)
    );
  }

  // alphebetize the owners list
  usersList.sort((a, b) =>
    a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
  );

  return (
    <ul className={`dropdown-menu result-dropdown-menu ${classes}`}>
      {usersList.map(user => (
        <li key={user.id}>
          <a
            onClick={() => {
              if (item.type === 'Result') {
                props.updateWorkPackageOwner(item.id, user.id);
              } else if (oldOwnerId) {
                if (item.id) props.editTaskOwner(item.id, oldOwnerId, user.id);
                else updateTemporaryTaskOwner(item.temporaryId, user.id);
              } else if (item.id) props.addTaskOwner(item.id, user.id);
              else updateTemporaryTaskOwner(item.temporaryId, user.id);
            }}
          >
            <span>{user.nickname || user.name}</span>
          </a>
        </li>
      ))}
      {currentOwnerId && (
        <li key="unassign-user">
          <a
            onClick={() => {
              if (item.type === 'Result') {
                props.updateWorkPackageOwner(item.id, null);
              } else if (item.id) props.removeTaskOwner(item.id, oldOwnerId);
              else updateTemporaryTaskOwner(item.temporaryId, null);
            }}
          >
            <span>&nbsp;</span>
          </a>
        </li>
      )}
    </ul>
  );
};

ChangeOwner.propTypes = {
  result: PropTypes.object,
  task: PropTypes.object,
  users: PropTypes.array,
  classes: PropTypes.string
};

ChangeOwner.defaultProps = {
  classes: '',
  users: [],
  result: {},
  task: {}
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateWorkPackageOwner,
      addTaskOwner,
      editTaskOwner,
      removeTaskOwner
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(ChangeOwner);
